/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareNumber7 = createReactComponent("square-number-7", "IconSquareNumber7", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 8h4l-2 8", key: "svg-1" }]
]);

export { IconSquareNumber7 as default };
//# sourceMappingURL=IconSquareNumber7.js.map
